import ReadOnlyMigrationEligibility from "shared/programs/migration-acceleration-program/2024/fund-request/components/read-only/MigrationEligibility/ReadOnlyMigrationEligibility";

export default ReadOnlyMigrationEligibility;
